const getQueryParam = (key, defaultValue) => {
  const value = new URLSearchParams(window.location.search).get(key);
  return value === null || value.trim() === '' ? defaultValue : value;
};

export {
  getQueryParam
}